import buildInfo from "@/buildInfo";

export default {
  "process.env": process.env,
  buildTime: buildInfo.buildTime,
  appName: '方舟物联网平台',
  consoleUrl: 'http://console.huadong2.fenydata.com/',
  docUrl: "http://doc.huadong2.fenydata.com"
}
